import React from 'react';
import { Linkedin, Clock } from 'lucide-react';
import { motion } from 'framer-motion';

export function LinkedInImport() {
  return (
    <motion.div 
      className="mb-8 p-4 border border-gray-200 rounded-lg bg-gray-50"
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
    >
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold flex items-center gap-2">
          <Linkedin className="w-5 h-5 text-[#0A66C2]" />
          Import from LinkedIn
        </h3>
        <span className="inline-flex items-center px-3 py-1 rounded-full text-sm 
          bg-indigo-100 text-indigo-800">
          <Clock className="w-4 h-4 mr-1" />
          Coming Soon
        </span>
      </div>

      <p className="mt-4 text-gray-600">
        Soon you'll be able to automatically import your:
      </p>
      <ul className="mt-2 space-y-1 text-gray-600">
        <li className="flex items-center">
          <span className="mr-2">•</span>
          Professional Experience
        </li>
        <li className="flex items-center">
          <span className="mr-2">•</span>
          Education History
        </li>
        <li className="flex items-center">
          <span className="mr-2">•</span>
          Skills & Endorsements
        </li>
        <li className="flex items-center">
          <span className="mr-2">•</span>
          Basic Information
        </li>
      </ul>
    </motion.div>
  );
}